<template>
  <footer class="footer">
    <!-- 链接导航区域 -->
    <nav class="footer-nav">
      <div
        v-for="section in footerSections"
        :key="section.title"
        class="footer-section"
      >
        <h3 class="section-title">{{ section.title }}</h3>
        <ul class="section-links">
          <li
            v-for="link in section.links"
            :key="link.name"
            class="link-item"
            @click="handleLinkClick(link.name)"
          >
            {{ link.name }}
          </li>
        </ul>
      </div>
    </nav>

    <!-- 版权信息区域 -->
    <div class="footer-copyright">
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
        class="beian-link"
      >
        <i class="el-icon-document"></i>
        网站备案编号：沪ICP备20006544号-1
      </a>
      <p class="copyright-text">
        WANCODE Education and Technology Co., Ltd.（Shanghai）All Rights Reserved.
        <br />
         Copyright © 2019~2026, 上海玩扣教育科技有限公司 提供技术支持
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'HomeBottom',

  data() {
    return {
      // 底部导航配置数据
      footerSections: [
        {
          title: '关于我们',
          links: [
            { name: '教师版', url: '' },
            { name: '加入我们', url: '' },
            { name: 'Scratch社区', url: '' }
          ]
        },
        {
          title: '联系我们',
          links: [
            { name: '联系我们', url: '' },
            { name: '学习交流', url: '' }
          ]
        },
        {
          title: '新手帮助',
          links: [
            { name: '客服微信', url: '' },
            { name: '使用手册', url: '' }
          ]
        },
        {
          title: '其他服务',
          links: [
            { name: '意见反馈', url: '' },
            { name: '忘记密码', url: '' }
          ]
        },
        {
          title: '服务协议',
          links: [
            { name: '用户协议', url: '' },
            { name: '隐私协议', url: '' },
            { name: '免责声明', url: '' }
          ]
        }
      ],
      // Scratch社区地址
      scratchBaseUrl: 'http://scratch.wancode.net'
    }
  },

  methods: {
    /**
     * 处理链接点击事件
     * @param {string} linkName - 链接名称
     */
    handleLinkClick(linkName) {
      console.log('底部链接点击:', linkName) // 调试日志
      if (linkName === 'Scratch社区') {
        this.openScratchCommunity()
      } else {
        this.$emit('clickBottomItem', linkName)
      }
    },

    /**
     * 打开Scratch社区页面
     */
    openScratchCommunity() {
      const token = localStorage.getItem('token')
      const sessionId = localStorage.getItem('sessionId')

      const url = token
        ? `${this.scratchBaseUrl}/#/token=${token}&sessionId=${sessionId}`
        : this.scratchBaseUrl

      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
// CSS变量定义
$footer-bg: #2c3e50;
$footer-text: #bdc3c7;
$footer-title: #ffffff;
$footer-hover: #3498db;
$footer-max-width: 1200px;
$transition-duration: 0.3s;

.footer {
  width: 100%;
  background: linear-gradient(180deg, $footer-bg 0%, darken($footer-bg, 8%) 100%);
  margin-top: 50px;
  padding-top: 40px;
}

// 导航区域
.footer-nav {
  max-width: $footer-max-width;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 20px 30px;
  gap: 20px;
}

.footer-section {
  flex: 1;
  min-width: 150px;
  text-align: center;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: $footer-title;
  margin-bottom: 16px;
  position: relative;
  padding-bottom: 10px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
    height: 2px;
    background: $footer-hover;
    border-radius: 1px;
  }
}

.section-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-item {
  font-size: 14px;
  line-height: 2;
  color: $footer-text;
  cursor: pointer;
  transition: all $transition-duration ease;

  &:hover {
    color: $footer-hover;
    transform: translateX(3px);
  }
}

// 版权区域
.footer-copyright {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 25px 20px;
  text-align: center;
  background: rgba(0, 0, 0, 0.15);
}

.beian-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: $footer-text;
  text-decoration: none;
  font-size: 13px;
  transition: color $transition-duration ease;

  &:hover {
    color: $footer-hover;
  }

  i {
    font-size: 14px;
  }
}

.copyright-text {
  margin-top: 15px;
  font-size: 12px;
  color: rgba($footer-text, 0.7);
  line-height: 1.8;
}

</style>
